import { FormatUtils } from "../Utils/FormatUtils.js";
/**
 * Calculates measures.
 */
export class MeasuresCalculator {
    constructor(main) {
        this._main = main;
    }
    get mechanicalAxisAP() {
        return this._main.toolsAP.mechanicalAxis;
    }
    get mechanicalAxisLT() {
        return this._main.toolsLT.mechanicalAxis;
    }
    get def_ap_LPFA() {
        return FormatUtils.angleRadiants(this.mechanicalAxisAP.femur.LPFA.value);
    }
    get def_ap_mLDFA() {
        return FormatUtils.angleRadiants(this.mechanicalAxisAP.femur.mLDFA.value);
    }
    get def_ap_MPTA() {
        return FormatUtils.angleRadiants(this.mechanicalAxisAP.tibia.MPTA.value);
    }
    get def_ap_LDTA() {
        return FormatUtils.angleRadiants(this.mechanicalAxisAP.tibia.LDTA.value);
    }
    get def_ap_JLCA() {
        return FormatUtils.angleRadiants(this.mechanicalAxisAP.JLCA.value);
    }
    get def_ap_MAD() {
        return FormatUtils.distance(this.mechanicalAxisAP.MAD.value);
    }
    get def_ap_MNSA() {
        return FormatUtils.angleRadiants(this.mechanicalAxisAP.femur.MNSA.value);
    }
    get def_ap_MPFA() {
        return FormatUtils.angleRadiants(this.mechanicalAxisAP.femur.MPFA.value);
    }
    get def_ap_aLDFA() {
        return FormatUtils.angleRadiants(this.mechanicalAxisAP.femur.aLDFA.value);
    }
    get def_ap_apexFemur() {
        return FormatUtils.angleRadiants(this.mechanicalAxisAP.femur.apexAngle.value);
    }
    get def_ap_apexFemurSign() {
        return FormatUtils.apexSign(this.mechanicalAxisAP.femur.apexAngleSign.value);
    }
    get def_ap_apexTibia() {
        return FormatUtils.angleRadiants(this.mechanicalAxisAP.tibia.apexAngle.value);
    }
    get def_ap_apexTibiaSign() {
        return FormatUtils.apexSign(this.mechanicalAxisAP.tibia.apexAngleSign.value);
    }
    get def_ap_kneeTranslation() {
        return FormatUtils.distance(this.mechanicalAxisAP.kneeTranslation.value);
    }
    get def_ap_fullLength() {
        return FormatUtils.distance(this.mechanicalAxisAP.length.value);
    }
    get def_ap_femurLength() {
        return FormatUtils.distance(this.mechanicalAxisAP.femur.length.value);
    }
    get def_ap_tibiaLength() {
        return FormatUtils.distance(this.mechanicalAxisAP.tibia.length.value);
    }
    get def_ap_LPFA_ctrlateral() {
        return FormatUtils.angleRadiants(this._main.toolsAP.contralateralMechanicalAxis.femur.LPFA.value);
    }
    get def_ap_mLDFA_ctrlateral() {
        return FormatUtils.angleRadiants(this._main.toolsAP.contralateralMechanicalAxis.femur.mLDFA.value);
    }
    get def_ap_MPTA_ctrlateral() {
        return FormatUtils.angleRadiants(this._main.toolsAP.contralateralMechanicalAxis.tibia.MPTA.value);
    }
    get def_ap_LDTA_ctrlateral() {
        return FormatUtils.angleRadiants(this._main.toolsAP.contralateralMechanicalAxis.tibia.LDTA.value);
    }
    get def_ap_JLCA_ctrlateral() {
        return FormatUtils.angleRadiants(this._main.toolsAP.contralateralMechanicalAxis.JLCA.value);
    }
    get def_ap_MAD_ctrlateral() {
        return FormatUtils.distance(this._main.toolsAP.contralateralMechanicalAxis.MAD.value);
    }
    get def_ap_MNSA_ctrlateral() {
        return FormatUtils.angleRadiants(this._main.toolsAP.contralateralMechanicalAxis.femur.MNSA.value);
    }
    get def_ap_MPFA_ctrlateral() {
        return FormatUtils.angleRadiants(this._main.toolsAP.contralateralMechanicalAxis.femur.MPFA.value);
    }
    get def_ap_aLDFA_ctrlateral() {
        return FormatUtils.angleRadiants(this._main.toolsAP.contralateralMechanicalAxis.femur.aLDFA.value);
    }
    get def_ap_kneeTranslation_ctrlateral() {
        return FormatUtils.distance(this._main.toolsAP.contralateralMechanicalAxis.kneeTranslation.value);
    }
    get def_ap_fullLength_ctrlateral() {
        return FormatUtils.distance(this._main.toolsAP.contralateralMechanicalAxis.length.value);
    }
    get def_ap_femurLength_ctrlateral() {
        return FormatUtils.distance(this._main.toolsAP.contralateralMechanicalAxis.femur.length.value);
    }
    get def_ap_tibiaLength_ctrlateral() {
        return FormatUtils.distance(this._main.toolsAP.contralateralMechanicalAxis.tibia.length.value); // TODO handle better the !
    }
    get def_lt_PDFA() {
        return this.mechanicalAxisLT.femur ? FormatUtils.angleRadiants(this.mechanicalAxisLT.femur.PDFA.value) : undefined;
    }
    get def_lt_PPTA() {
        return this.mechanicalAxisLT.tibia ? FormatUtils.angleRadiants(this.mechanicalAxisLT.tibia.PPTA.value) : undefined;
    }
    get def_lt_ADTA() {
        return this.mechanicalAxisLT.tibia ? FormatUtils.angleRadiants(this.mechanicalAxisLT.tibia.ADTA.value) : undefined;
    }
    get def_lt_kneeTranslation() {
        const mechAxis = this._main.toolsLT.mechanicalAxis;
        return mechAxis.kneeTranslation?.value ? FormatUtils.distance(mechAxis.kneeTranslation.value) : undefined; // TODO check if 0?
    }
    get def_lt_apexTibia() {
        const mechAxis = this._main.toolsLT.mechanicalAxis;
        return mechAxis.tibia ? FormatUtils.angleRadiants(mechAxis.tibia.apexAngle.value) : undefined;
    }
    get def_lt_apexTibiaSign() {
        const mechAxis = this._main.toolsLT.mechanicalAxis;
        return mechAxis.tibia ? FormatUtils.apexSign(mechAxis.tibia.apexAngleSign.value) : undefined;
    }
}
//# sourceMappingURL=MeasuresCalculator.js.map